import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import type { DocumentType } from '../types/api';

export function useDocumentTypes() {
  return useQuery({
    queryKey: ['document-types'],
    staleTime: 60 * 60 * 1000, // rarely changes
    queryFn: async () => {
      const res = await api.get<{ document_types: DocumentType[] }>('/document-types');
      return res.document_types;
    },
  });
}
